module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-your-claims__table-container"
  }, [_c('div', {
    staticClass: "flex-grid flex-state-buttons"
  }, [_c('h3'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "a-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showInterest),
      expression: "showInterest"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showInterest) ? _vm._i(_vm.showInterest, null) > -1 : (_vm.showInterest)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.showInterest,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showInterest = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showInterest = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showInterest = $$c
        }
      }, _vm.updateTotals]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "text"
    }
  }, [_vm._v("Show Interest")])])])]), _vm._v(" "), _c('table', {
    staticClass: "a-table u-full-width"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("General Damages")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getGeneralDamages)))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_general_damages",
      "label": "",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.generalDamages),
      expression: "generalDamages",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.generalDamages)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.generalDamages = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getGeneralDamages - _vm.generalDamages)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getGeneralDamages, _vm.generalDamages)) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Past Loss Of Earnings")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getIncomeValue('pastLossOfEarningsNetTotal'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_loss_of_earnings",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastLossOfEarnings),
      expression: "pastLossOfEarnings",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastLossOfEarnings)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pastLossOfEarnings = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getIncomeValue('pastLossOfEarningsNetTotal') - _vm.pastLossOfEarnings)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getIncomeValue('pastLossOfEarningsNetTotal'), _vm.pastLossOfEarnings)) + "%")])]), _vm._v(" "), (_vm.showInterest) ? _c('tr', [_c('td', [_vm._v("Past Loss Of Earnings - Interest ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('pastLossOfEarningsWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_loss_of_earnings",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastLossOfEarningsInterest),
      expression: "pastLossOfEarningsInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastLossOfEarningsInterest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pastLossOfEarningsInterest = _vm._n($event.target.value)
      }, _vm.updateTotals],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('pastLossOfEarningsWithInterest') - _vm.pastLossOfEarningsInterest)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getLossValue('pastLossOfEarningsWithInterest'), _vm.pastLossOfEarningsInterest)) + "%\n            ")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Past Cost of Travel")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('pastCostOfTravel'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_cost_of_travel",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfTravel),
      expression: "pastCostOfTravel",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastCostOfTravel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfTravel = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('pastCostOfTravel') - _vm.pastCostOfTravel)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getLossValue('pastCostOfTravel'), _vm.pastCostOfTravel)) + "%")])]), _vm._v(" "), (_vm.showInterest) ? _c('tr', [_c('td', [_vm._v("Past Cost of Travel - Interest")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('pastCostOfTravelWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_cost_of_travel",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfTravelInterest),
      expression: "pastCostOfTravelInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastCostOfTravelInterest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfTravelInterest = _vm._n($event.target.value)
      }, _vm.updateTotals],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('pastCostOfTravelWithInterest') - _vm.pastCostOfTravelInterest)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getLossValue('pastCostOfTravelWithInterest'), _vm.pastCostOfTravelInterest)) + "%")])]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.getAllCustomHeadOfLoss), function(custom) {
    return _c('custom-head-of-loss', {
      attrs: {
        "headOfLoss": custom,
        "index": _vm.index,
        "showInterest": _vm.showInterest
      },
      on: {
        "update": _vm.updateTotals
      }
    })
  }), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Past Cost of Care")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('pastCostOfCare'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_cost_of_care",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfCare),
      expression: "pastCostOfCare",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastCostOfCare)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfCare = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('pastCostOfCare') - _vm.pastCostOfCare)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getLossValue('pastCostOfCare'), _vm.pastCostOfCare)) + "%")])]), _vm._v(" "), (_vm.showInterest) ? _c('tr', [_c('td', [_vm._v("Past Cost of Care - Interest")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('pastCostOfCareWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_cost_of_care",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfCareInterest),
      expression: "pastCostOfCareInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastCostOfCareInterest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfCareInterest = _vm._n($event.target.value)
      }, _vm.updateTotals],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('pastCostOfCareWithInterest') - _vm.pastCostOfCareInterest)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getLossValue('pastCostOfCareWithInterest'), _vm.pastCostOfCareInterest)) + "%")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Past Cost of Services")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('pastCostOfServices'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_cost_of_care",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfServices),
      expression: "pastCostOfServices",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastCostOfServices)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfServices = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('pastCostOfServices') - _vm.pastCostOfServices)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getLossValue('pastCostOfServices'), _vm.pastCostOfServices)) + "%")])]), _vm._v(" "), (_vm.showInterest) ? _c('tr', [_c('td', [_vm._v("Past Cost of Services - Interest")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('pastCostOfServicesWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_past_cost_of_care",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pastCostOfServicesInterest),
      expression: "pastCostOfServicesInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pastCostOfServicesInterest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pastCostOfServicesInterest = _vm._n($event.target.value)
      }, _vm.updateTotals],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('pastCostOfServicesWithInterest') - _vm.pastCostOfServicesInterest)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getLossValue('pastCostOfServicesWithInterest'), _vm.pastCostOfServicesInterest)) + "%")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Miscellaneous")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('misc'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_misc",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.misc),
      expression: "misc",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.misc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.misc = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('misc') - _vm.misc)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getLossValue('misc'), _vm.misc)) + "%")])]), _vm._v(" "), (_vm.showInterest) ? _c('tr', [_c('td', [_vm._v("Miscellaneous - Interest")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('miscWithInterest'))))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_misc",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.miscInterest),
      expression: "miscInterest",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.miscInterest)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.miscInterest = _vm._n($event.target.value)
      }, _vm.updateTotals],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getLossValue('miscWithInterest') - _vm.miscInterest)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.getLossValue('miscWithInterest'), _vm.miscInterest)) + "%")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Future Loss of Pension ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.futurePensionTotal)))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_misc",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.futureLossOfPension),
      expression: "futureLossOfPension",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.futureLossOfPension)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.futureLossOfPension = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.futurePensionTotal - _vm.futureLossOfPension)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.futurePensionTotal, _vm.futureLossOfPension)) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Future Loss of Care")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.futureCareTotal)))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_misc",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.futureCostOfCare),
      expression: "futureCostOfCare",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.futureCostOfCare)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.futureCostOfCare = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.futureCareTotal - _vm.futureCostOfCare)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.futureCareTotal, _vm.futureCostOfCare)) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Future Loss of Services")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.futureServicesTotal)))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_misc",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.futureCostOfServices),
      expression: "futureCostOfServices",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.futureCostOfServices)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.futureCostOfServices = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.futureServicesTotal - _vm.futureCostOfServices)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.futureServicesTotal, _vm.futureCostOfServices)) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Future Loss of Earnings")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.lossResult)))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "for": "dependants_assessment_misc",
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.futureLossOfEarnings),
      expression: "futureLossOfEarnings",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.futureLossOfEarnings)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.futureLossOfEarnings = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.lossResult - _vm.futureLossOfEarnings)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.lossResult, _vm.futureLossOfEarnings)) + "%")])])]), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headsOfLossTotal)) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.dependantsHeadsOfLossTotal)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.differenceTotal)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.headsOfLossTotal, _vm.dependantsHeadsOfLossTotal)) + "%")])])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_c('h2', [_vm._v("Heads of Loss")])]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_c('h2', [_vm._v("Defendant's Assessment")])]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_c('h2', [_vm._v("Claimant's Assessment")])]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('h2', [_vm._v("Difference")])])]), _vm._v(" "), _c('tr', [_c('th', [_c('h2', [_vm._v("£")])]), _vm._v(" "), _c('th', [_c('h2', [_vm._v("Percentage")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-85c680ce!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/documents/PersonalComparisonSchedule.vue
// module id = 1764
// module chunks = 0